import { PROPERTY_NAME, PROPERTY_VALUE, TYPE_KEY } from "../common/constant";
import rest from "../common/rest";
import { getProgramInstanceFacetParameterString } from "../utils/ApiUtils";
import { beginLoading, endLoading } from "./loadingSpinner";
import { createBackendErrorMessages, createErrorMessages, messagesReceived } from "./message";

import FileSaver from "file-saver";

const TIME_FACET = "INDICATOR.TIME_FACET";
const CLEAR_CHARTS = "INDICATOR.CLEAR_CHARTS";
const LABEL_CHANGED_ACTION = "INDICATOR.LABEL_CHANGED_ACTION";
const PROPERTY_CHANGED_ACTION = "INDICATOR.PROPERTY_CHANGED_ACTION";
const SET_INDICATOR_GROUPS_ACTION = "INDICATOR.SET_INDICATOR_GROUPS_ACTION";

const LOAD_INDICATORS = "INDICATOR.LOAD_INDICATORS";

export const RECEIVED_TIME_FACET = "timeFacet";
export const LABEL = "label";
export const CURRENT_INDICATOR_GROUP = "currentIndicatorGroup";
export const INDICATOR_GROUPS = "indicatorGroups";
export const INDICATOR_GROUP_ID = "groupId";
export const INDICATORS = "indicators";
export const PROGRAM_INSTANCE_FOREIGN_IDS = "programInstanceForeignIds";
export const PROGRAM_SELECTION = "programSelection";
export const PROGRAM_ID_LIST = "programIdList";

const initialState = {
  [INDICATOR_GROUPS]: null,
  [INDICATOR_GROUP_ID]: null,
  [RECEIVED_TIME_FACET]: null,
  [LABEL]: [],
  [PROGRAM_SELECTION]: {},
  [PROGRAM_ID_LIST]: []
};

let reducer = (state = initialState, action) => {
  let newState;
  switch (action[TYPE_KEY]) {
    case LOAD_INDICATORS:
      newState = {
        ...state,
        [INDICATORS]: action[INDICATORS],
        [INDICATOR_GROUP_ID]: action[INDICATOR_GROUP_ID]
      };
      break;
    case TIME_FACET:
      newState = {
        ...state,
        [RECEIVED_TIME_FACET]: action[RECEIVED_TIME_FACET]
      };
      break;
    case SET_INDICATOR_GROUPS_ACTION:
      newState = {
        ...state,
        [INDICATOR_GROUPS]: action[INDICATOR_GROUPS]
      };
      break;
    case LABEL_CHANGED_ACTION:
      newState = {
        ...state,
        [LABEL]: action[LABEL]
      };
      break;
    case PROPERTY_CHANGED_ACTION:
      newState = Object.assign({}, state, {
        [action[PROPERTY_NAME]]: action[PROPERTY_VALUE]
      });
      break;
    default:
      newState = { ...state };
      break;
  }
  return newState;
};

export function getTimeFacetForEvaluation() {
  return (dispatch) => {
    rest.doGet(`/survey/evaluations/facets/time`).then(
      (time) => {
        dispatch(loadSuccessfulTimeFacet(time.timeFacets[0]));
      },
      (reason) => {
        dispatch(messagesReceived(createBackendErrorMessages(reason)));
      }
    );
  };
}

export function removeDataForAnalyticsReport() {
  return (dispatch) => {
    dispatch(clearCharts());
    dispatch(propertyChange());
  };
}

export function clearCharts() {
  return {
    [TYPE_KEY]: CLEAR_CHARTS
  };
}

export function loadSuccessfulTimeFacet(data) {
  return {
    [TYPE_KEY]: TIME_FACET,
    [RECEIVED_TIME_FACET]: data
  };
}

export function yearsChange(label) {
  return {
    [TYPE_KEY]: LABEL_CHANGED_ACTION,
    [LABEL]: label
  };
}

export function programInstanceChange(programInstanceId){
  return {
    [TYPE_KEY]: LABEL_CHANGED_ACTION,
    [LABEL]: programInstanceId
  };
}

/**
 * Change Property Action
 */
export function propertyChange(propertyName, propertyValue) {
  return {
    [TYPE_KEY]: PROPERTY_CHANGED_ACTION,
    [PROPERTY_NAME]: propertyName,
    [PROPERTY_VALUE]: propertyValue
  };
}

export function loadIndicatorGroups(fundingArea) {
  return (dispatch) => {
    let url = `/survey/indicatorGroups/?fundingAreaRefId=${fundingArea}`;
    rest.doGet(url).then(
      (json) => {
        if (json) {
          dispatch(indicatorGroupsLoadedSuccessful(json.groups));
        } else {
          dispatch(messagesReceived(createErrorMessages(json)));
        }
      },
      (reason) => {
        dispatch(messagesReceived(createBackendErrorMessages(reason)));
      }
    );
  };
}

export function loadIndicatorGroupData(
  groupId,
  selectedProgram,
  status,
  selectedTimeFacets,
  programForeignIds
) {
  return (dispatch, getState) => {
    dispatch(beginLoading());

    let url = `/survey/indicatorGroups/${groupId}/indicators/?`;

    if (selectedTimeFacets && selectedTimeFacets.length > 0) {
      selectedTimeFacets.forEach((facet, index) => {
        url += `&timeFacets[${index}].from=${facet.startTime}&timeFacets[${index}].to=${facet.endTime}`;
      });
    }
    if (status) {
      url += `&status=${status}`;
    }
    if (selectedProgram) {
      url += `&programRefId=${selectedProgram}`;
    }
    if (programForeignIds !== null && programForeignIds !== "") {
      url += `&programForeignIds=${programForeignIds}`;
    }
    const instanceRefIds = getState().indicatorGroup.programInstanceForeignIds;
    url += getProgramInstanceFacetParameterString(instanceRefIds);

    rest.doGet(url).then(
      (json) => {
        if (json) {
          dispatch(indicatorsLoadedSuccessful(json, groupId));
          dispatch(endLoading());
        } else {
          dispatch(messagesReceived(createErrorMessages(json)));
          dispatch(endLoading());
        }
      },
      (reason) => {
        dispatch(messagesReceived(createBackendErrorMessages(reason)));
        dispatch(endLoading());
      }
    );
  };
}

function indicatorsLoadedSuccessful(group, id) {
  return (dispatch) => {
    dispatch({
      [TYPE_KEY]: LOAD_INDICATORS,
      [INDICATOR_GROUP_ID]: id,
      [INDICATORS]: group
    });
  };
}

function indicatorGroupsLoadedSuccessful(data) {
  return {
    [TYPE_KEY]: SET_INDICATOR_GROUPS_ACTION,
    [INDICATOR_GROUPS]: data
  };
}

export function downloadIndicatorCSV(
  groupId,
  selectedProgram,
  status,
  selectedTimeFacets,
  programForeignIds,
  fileName
) {
  return (dispatch, getState) => {
    dispatch(beginLoading());

    // TODO mwiegand implement correct service call, code copied from download program csv

    let url = `/survey/evaluations/frequency`;

    url += `/indicatorExport${groupId}?`;

    if (selectedTimeFacets && selectedTimeFacets.length > 0) {
      selectedTimeFacets.forEach((facet, index) => {
        url += `&timeFacets[${index}].from=${facet.startTime}&timeFacets[${index}].to=${facet.endTime}`;
      });
    }
    if (status) {
      url += `&status=${status}`;
    }
    if (selectedProgram) {
      url += `&programRefId=${selectedProgram}`;
    }
    if (programForeignIds !== null && programForeignIds !== "") {
      url += `&programForeignIds=${programForeignIds}`;
    }

    const instanceRefIds = getState().indicatorGroup.programInstanceForeignIds;
    url += getProgramInstanceFacetParameterString(instanceRefIds);

    rest.doGet(url, "text/csv").then(
      (response) => {
        try {
          const csv = response.response || response;
          let blob = new Blob(["\ufeff", csv], { type: "text/csv;charset=utf-8" });
          let fileNameForDownload;
          if (!fileName) {
            fileNameForDownload = "indicatorDownload_" + new Date().getTime() + "__" + groupId;
          } else {
            fileNameForDownload = fileName;
          }

          FileSaver.saveAs(blob, fileNameForDownload + ".csv");
          dispatch(endLoading());
        } catch (err) {
          dispatch(messagesReceived(createErrorMessages(err)));
          dispatch(endLoading());
        }
      },
      (reason) => {
        dispatch(messagesReceived(createBackendErrorMessages(reason)));
        dispatch(endLoading());
      }
    );
  };
}

export default reducer;
